var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.route === 'lab')?_c('lab-view'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }